<template>
    <div style="padding: 20px; height: 100%; box-sizing: border-box">
        <div class="cf" style="padding:10px">
            <div class="fl">
                <el-button type="primary" @click="create()" size="mini"> 创建模型</el-button>
                <el-input v-model="search.keyWord" placeholder="输入名称或编码" size="mini"
                          style="width: 150px; margin: 0 10px" @change="searchInit()" clearable></el-input>
            </div>
            <div class="fr">
                <el-tooltip class="item" effect="dark" content="查询" placement="top">
                    <el-button size="mini" @click="page.current=1; init()" circle icon="el-icon-search">
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <el-table :data="data" border size="mini" style="width: 100%" height="80%" v-loading="loading">
            <template slot="empty">
                <el-empty></el-empty>
            </template>
            <el-table-column prop="name" label="模型名称" min-width="180" show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column prop="code" label="模型编码" min-width="180" show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column prop="dataName" label="数据库名称" min-width="180" show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column prop="tableName" label="数据库表名" width="180" show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column fixed="right" width="400" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="formConfig(scope.row)">Form表单</el-button>
                    <el-button size="mini" type="text" @click="headerFormConfig(scope.row)">头部按钮</el-button>
                    <el-button size="mini" type="text" @click="lineFormConfig(scope.row)">行按钮</el-button>
                    <el-button size="mini" type="text" @click="footerFormConfig(scope.row)">底部按钮</el-button>
                    <el-button size="mini" type="text" @click="fieldList(scope.row)">字段列表</el-button>
                    <el-button size="mini" type="text" @click="edit(scope.row)">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: left; padding: 10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="page.current" :page-sizes="[20, 50, 80, 100]" :page-size="page.size"
                           layout="total, sizes, prev, pager, next, jumper" :total="page.total" background>
            </el-pagination>
        </div>
        <base-detail ref="detail" @init="init()"/>
        <field-list ref="fieldList" @init="init()"/>
        <form-detail ref="formDetail" @init="init()"/>
    </div>
</template>

<script>
import baseDetail from './components/baseDetail'
import fieldList from './components/fieldList'
import formDetail from './components/formDetail'

export default {
    data() {
        return {
            data: [],
            allAlign: 'center',
            loading: false,
            tableHeight: window.innerHeight - 238 + 'px',
            page: {
                size: 20,
                current: 1,
                total: 0
            },
            search: {}
        }
    },
    components: {baseDetail, fieldList, formDetail},
    created() {
        this.init()
    },
    methods: {
        init() {
            this.$set(this, 'loading', true)
            const params = {
                params: {
                    pageNum: this.page.current,
                    pageSize: this.page.size
                }
            }
            for (let key in this.search) {
                if (this.search[key])
                    params.params[key] = this.search[key]
            }
            this.$axios.get('/query/basicsModel/list', params).then(res => {
                const data = res.data.data
                this.data = data.list
                this.page.total = data.total
                this.loading = false
            }).catch(err => {
                console.log('model Err:', err)
                this.$set(this, 'loading', false)
            })
        },

        searchInit() {
            this.page.current = 1
            this.init()
        },

        handleSizeChange(val) {
            this.page.size = val
            this.init()
        },
        handleCurrentChange(val) {
            this.page.current = val
            this.init()
        },

        create() {
            const data = {
                data: {isJoin: false, isSql: false, isTenant: true, isPlatform: false},
                name: '创建模型',
                isCreate: true
            }
            this.$refs.detail.display(data)
        },

        edit(row) {
            const data = {data: row, name: '修改模型', isCreate: false}
            this.$refs.detail.display(data)
        },

        fieldList(row) {
            const data = {row: row, name: '字段列表'}
            this.$refs.fieldList.display(data)
        },

        formConfig(row) {
            this.$axios.get(`/query/basicsModel/get/${row.id}`).then(res => {
                const resData = res.data.data
                const data = {
                    data: ['', null, undefined].includes(resData.formCreate) ? {id: resData.id} : {
                        extSettings: resData.formCreate,
                        id: resData.id
                    },
                    type: 'form',
                    name: `${row.name}Form表单配置`
                }
                this.$refs.formDetail.display(data)
            })
        },
        headerFormConfig(row) {
            this.$axios.get(`/query/basicsModel/get/${row.id}`).then(res => {
                const resData = res.data.data
                const data = {
                    data: ['', null, undefined].includes(resData.headerButton) ? {id: resData.id} : {
                        extSettings: resData.headerButton,
                        id: resData.id
                    },
                    type: 'headerButton',
                    name: `${row.name}头部按钮配置`
                }
                this.$refs.formDetail.display(data)
            })
        },
        lineFormConfig(row) {
            this.$axios.get(`/query/basicsModel/get/${row.id}`).then(res => {
                const resData = res.data.data
                const data = {
                    data: ['', null, undefined].includes(resData.lineButton) ? {id: resData.id} : {
                        extSettings: resData.lineButton,
                        id: resData.id
                    },
                    type: 'lineButton',
                    name: `${row.name}行按钮配置`
                }
                this.$refs.formDetail.display(data)
            })
        },
        footerFormConfig(row) {
            this.$axios.get(`/query/basicsModel/get/${row.id}`).then(res => {
                const resData = res.data.data
                const data = {
                    data: ['', null, undefined].includes(resData.footerButton) ? {id: resData.id} : {
                        extSettings: resData.footerButton,
                        id: resData.id
                    },
                    type: 'footerButton',
                    name: `${row.name}底部按钮配置`
                }
                this.$refs.formDetail.display(data)
            })
        }
    }
}
</script>

<style scoped>
.cf {
    overflow: hidden
}

.fl {
    float: left;
}

.fr {
    float: right;
}
</style>
